module.exports = __webpack_public_path__ + "img/shipo-icon-checkmark.d8043db1.svg";